import { jsx as _jsx } from "react/jsx-runtime";
import { KeyboardShortcutsPage } from 'pages/keyboard-shortcuts/ui/keyboard-shortcuts-page';
export const keyboard_shortcuts_routes = [
    {
        path: `/keyboard_shortcuts`,
        element: _jsx(KeyboardShortcutsPage, {}),
        children: [],
    },
];
